
// ? Calucate Age in Months
export const calculateAgeInMonths = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const yearsDifference = today.getFullYear() - birthDate.getFullYear();
  const monthsDifference = today.getMonth() - birthDate.getMonth();
  const totalMonths = yearsDifference * 12 + monthsDifference;

  if (today.getDate() < birthDate.getDate()) {
    return totalMonths - 1;
  }
  return totalMonths;
};
export const calculateGestationalAgeInMonths = (actual, adjusted) => {
if (!adjusted) {
  return 0
}
if (actual < adjusted) {
  return 0
}
const diffDays = actual - adjusted;
console.log(diffDays);

const months = Math.floor(diffDays / 30);

return months < 1 ? 0 : months;
};



// ? Calculate Age in Days
export const caluclateGestationalAgeInDays = (dob,edd) => {
if (!edd) {
  return 0
}
  const birthDate = new Date(dob);
  const eddDate = new Date(edd);
  if (birthDate > eddDate) {
    return 0
  }
  
  const diffTime = Math.abs(eddDate - birthDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
export const caluclateAgeinDays = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const diffTime = (today - birthDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const getFormattedDate = (date) => {
const visitDate = new Date(date);
const formattedVisitDate = visitDate.toLocaleString("en-CA"); // 'YYYY-MM-DDTHH:mm:ss.sssZ'
const formattedForBackend =
  formattedVisitDate.replace("T", " ").slice(0, 19) + "+0000";
return formattedForBackend;
};

export const getDateAndYear = (date) => {
  const newDate =  new Date(date)
  return newDate.toDateString().slice(4)
}